// Protection ultra-robuste contre la corruption de texte
export const TEXT_CORRUPTION_MAP = Object.freeze({
  // Corruptions détectées et corrections
  'peine': 'pain',
  'paines': 'pains',
  'action': 'stock',
  'actions': 'stocks',
  'vient': 'vente',
  'viennent': 'ventes',
  'retire': 'retour',
  'retirent': 'retours',
  'product': 'production',
  'products': 'productions'
});

// Constantes fixes inaltérables
export const IMMUTABLE_TEXTS = Object.freeze({
  // Sections principales
  DASHBOARD: 'Dashboard',
  STOCK: 'Stock',
  PRODUCTION: 'Production', 
  VENTES: 'Ventes',
  RETOURS: 'Retours',
  DEPENSES: 'Dépenses',
  RAPPORTS: 'Rapports',
  GERER: 'Gérer',
  
  // Guichets (JAMAIS modifiés)
  COUNTER_PAIN: 'pain',
  COUNTER_VIENNOISERIE: 'viennoiserie',
  COUNTER_GATEAUX: 'gateaux',
  
  // Affichage guichets
  DISPLAY_PAINS: 'Pains',
  DISPLAY_VIENNOISERIE: 'Viennoiserie',
  DISPLAY_GATEAUX: 'Gâteaux',
  
  // Produits fixes
  PAIN_150F: 'Pain de 150F',
  PAIN_200F: 'Pain de 200F',
  
  // Champs
  QUANTITE: 'Quantité',
  DESIGNATION: 'Désignation',
  PRIX: 'Prix',
  MONTANT: 'Montant'
});

// Fonction de correction automatique
export const correctCorruptedText = (text) => {
  if (!text || typeof text !== 'string') return text;
  
  let correctedText = text.toLowerCase();
  
  // Appliquer les corrections connues
  for (const [corrupted, correct] of Object.entries(TEXT_CORRUPTION_MAP)) {
    correctedText = correctedText.replace(new RegExp(corrupted, 'gi'), correct);
  }
  
  return correctedText;
};

// Middleware de nettoyage des données backend
export const cleanBackendText = (data) => {
  if (!data) return data;
  
  if (typeof data === 'string') {
    return correctCorruptedText(data);
  }
  
  if (Array.isArray(data)) {
    return data.map(item => cleanBackendText(item));
  }
  
  if (typeof data === 'object') {
    const cleaned = {};
    for (const [key, value] of Object.entries(data)) {
      cleaned[key] = cleanBackendText(value);
    }
    return cleaned;
  }
  
  return data;
};

// Validation stricte des guichets
export const validateCounterName = (counterValue) => {
  const validCounters = {
    'pain': IMMUTABLE_TEXTS.COUNTER_PAIN,
    'peine': IMMUTABLE_TEXTS.COUNTER_PAIN, // Correction automatique
    'viennoiserie': IMMUTABLE_TEXTS.COUNTER_VIENNOISERIE,
    'gateaux': IMMUTABLE_TEXTS.COUNTER_GATEAUX
  };
  
  const normalized = counterValue?.toLowerCase();
  return validCounters[normalized] || IMMUTABLE_TEXTS.COUNTER_PAIN;
};

// Mapping sécurisé pour l'affichage
export const getSecureDisplayName = (key, type) => {
  switch (type) {
    case 'counter':
      return {
        'pain': IMMUTABLE_TEXTS.DISPLAY_PAINS,
        'viennoiserie': IMMUTABLE_TEXTS.DISPLAY_VIENNOISERIE,
        'gateaux': IMMUTABLE_TEXTS.DISPLAY_GATEAUX
      }[validateCounterName(key)] || IMMUTABLE_TEXTS.DISPLAY_PAINS;
      
    case 'section':
      return {
        'dashboard': IMMUTABLE_TEXTS.DASHBOARD,
        'stock': IMMUTABLE_TEXTS.STOCK,
        'action': IMMUTABLE_TEXTS.STOCK, // Correction
        'production': IMMUTABLE_TEXTS.PRODUCTION,
        'ventes': IMMUTABLE_TEXTS.VENTES,
        'retours': IMMUTABLE_TEXTS.RETOURS,
        'depenses': IMMUTABLE_TEXTS.DEPENSES,
        'rapports': IMMUTABLE_TEXTS.RAPPORTS
      }[key?.toLowerCase()] || key;
      
    case 'product':
      return {
        'c9a756d6-08c1-45e0-9a47-235e3252eb26': IMMUTABLE_TEXTS.PAIN_150F,
        'aea74b0b-e88a-4897-bc63-a510d55a9d2c': IMMUTABLE_TEXTS.PAIN_200F
      }[key] || key;
      
    default:
      return correctCorruptedText(key) || key;
  }
};

// Intercepteur pour les réponses API
export const interceptApiResponse = (data) => {
  if (!data) return data;
  
  // Si c'est un produit
  if (data.name && data.counter) {
    return {
      ...data,
      counter: validateCounterName(data.counter),
      name: getSecureDisplayName(data.id, 'product') || data.name
    };
  }
  
  // Si c'est une liste de produits
  if (Array.isArray(data) && data[0]?.counter) {
    return data.map(item => interceptApiResponse(item));
  }
  
  return cleanBackendText(data);
};

export default {
  correctCorruptedText,
  cleanBackendText,
  validateCounterName,
  getSecureDisplayName,
  interceptApiResponse,
  IMMUTABLE_TEXTS,
  TEXT_CORRUPTION_MAP
};